import { BaseAPI } from './BaseAPI.js'
import { ChannelSessionMessage } from '../types/index.js'

export default class ChannelSessionMessagesAPI extends BaseAPI<ChannelSessionMessage> {
  override get resource(): string {
    return '/channelSessionMessages'
  }

  public async forward(
    id: number | string,
    data: { forwardTo: string; additionalMessage?: string },
  ): Promise<any> {
    const result = await this._client.post(
      `${this.resource}/${id}/forward`,
      data,
    )
    return result.data
  }
}
